<template>
  <div class="d-flex flex-grow-1">
    <div @click.stop="localDialog = true" class="flex-grow-1">
      <slot></slot>
    </div>

    <v-dialog v-model="localDialog" max-width="500px">
      <v-card>
        <v-card-title class="grey--text text--darken-2 d-flex align-center">
          {{ title }}
          <v-btn
            small
            elevation="0"
            text
            icon
            class="ml-auto rounded-0"
            @click="localDialog = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-4">
          {{ message }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      localDialog: this.dialog, // mirror prop value
    };
  },
  watch: {
    // watch for changes in the prop and update the local copy
    dialog(val) {
      this.localDialog = val;
    },
    // watch for changes in the local copy and emit an update to the parent
    localDialog(val) {
      this.$emit('update:dialog', val);
    },
  },
  mounted() {
    console.log("mounted");
  },
};
</script>
